import "./Faculty.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { AxiosInstance } from "../../../../axios";
// import CategorySubject from "./CategorySubject";
import { validatePanelMember } from "./validation";
import AddJobInfo from "./AddJobInfo";
import intlTelInput from "intl-tel-input";
import toast from "react-hot-toast";

function AddPanelMember() {
  const txtPanelFName = useRef(null);
  const txtPanelLName = useRef(null);
  const txtPanelPno = useRef(null);
  const txtPanelEmail = useRef(null);
  const txtPanelStatus = useRef(null);
  const txtPanelDes = useRef(null);
  const txtPanelDept = useRef(null);

  const { userId } = useParams();
  const navigate = useNavigate();
  const [fData, setFormData] = useState({
    fname: "",
    lname: "",
    phoneNumber: "",
    phone_code: "+91",
    email: "",
    status: "",
    department: "",
    designation: "",
    is_eligible_class: "",
  });
  const [category, setCategory] = useState([]);
  const [addJob, setAddJob] = useState([
    {
      id: 1,
      department_id: "",
      department: "",
      designation_id: "",
      exp_designation: "",
      designationOptions: [],
    },
  ]);
  const [error, setError] = useState([]);
  const [errDep, setErrDep] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [department, setDepartment] = useState([]);
  // const [subject, setSubject] = useState([]);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  useEffect(() => {
    AxiosInstance.get("api/all/getDepartment/3")
      .then((res) => {
        const sortedDepartments = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.id,
            label: item.name,
            id: item.id,
          }));
        setDepartment(sortedDepartments);
      })
      .catch((error) => {
        return error;
      });
    // Initialize intl-tel-input on component mount
    const iti = intlTelInput(txtPanelPno.current, {
      // Add options as needed, refer to the intl-tel-input documentation
      initialCountry: "in",
      separateDialCode: true,
    });

    // You can listen for changes if needed
    txtPanelPno.current.addEventListener("countrychange", () => {
      const selectedCountryData = iti.getSelectedCountryData();
      setFormData((prevFields) => ({
        ...prevFields,
        phone_code: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
      }));
    });

    // Clean up on component unmount
    return () => {
      iti.destroy();
    };
  }, []);

  useEffect(() => {
    if (userId) {
      AxiosInstance.post("api/staff/view", { user_id: userId })
        .then((res) => {
          if (res.data.status === true) {
            setFormData({
              fname: res.data.data.first_name,
              lname: res.data.data.last_name,
              phoneNumber: res.data.data.mobile_no,
              phone_code: res.data.data.country_code,
              email: res.data.data.email,
              status: res.data.data.status,
              is_eligible_class: res.data.data.is_eligible_class,
            });
            const addj = res.data.data.subject.map((item, index) => ({
              id: index + 1,
              department_id: item.department_id,
              department: item.department,
              exp_designation: item.exp_designation,
              designation_id: item.designation_id,
            }));
            // Updating the state with the modified data
            setAddJob(addj);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [userId]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const DeleteAddJobinfo = (id, name) => {
    setAddJob((prevState) =>
      prevState
        .filter((item) => item.id !== id)
        .map((item, index) => ({ ...item, id: index + 1 }))
    );
  };

  const GetDesignation = (depId, index) => {
    AxiosInstance.get(`api/all/getDesignation/3/${depId}`)
      .then((res) => {
        // const designation = res.data.data
        //   .sort((a, b) => a.name.localeCompare(b.name))
        //   .map((item, index) => ({
        //     value: item.id,
        //     label: item.name,
        //   }));
        // setDesignation(designation);

        const designationOptions = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));

        setAddJob((prevJobs) => {
          const updatedJobs = [...prevJobs];
          updatedJobs[index] = {
            ...updatedJobs[index],
            designationOptions: designationOptions,
          };

          return updatedJobs;
        });
      })
      .catch((error) => {
        return error;
      });
  };

  const handleAddJobinfo = () => {
    setAddJob((prevState) => [
      ...prevState,
      {
        id: prevState.length > 0 ? prevState.length + 1 : 1,
        department: "",
        exp_designation: "",
      },
    ]);
  };

  const handleChangeAjob = (e, id) => {
    const { name, value } = e.target;
    setAddJob((prevState) => {
      return prevState.map((q) => {
        if (q.id === id) {
          return { ...q, [name]: value };
        }
        return q;
      });
    });
  };

  const handleChangeAjobs = (option, id, name, index) => {
    if (!option) return;

    // Update job data
    setAddJob((prevState) =>
      prevState.map((q) => {
        if (q.id === id) {
          if (name === "department") {
            return {
              ...q,
              department: option.label,
              department_id: option.value,
              exp_designation: "",
              designation_id: "",
            };
          } else if (name === "exp_designation") {
            return {
              ...q,
              exp_designation: option.label,
              designation_id: option.value,
            };
          }
        }
        return q;
      })
    );

    // Update error
    setErrDep((prevErr) =>
      prevErr.map((err, index) => {
        const jobIndex = addJob.findIndex((item) => item.id === id);
        if (index !== jobIndex) return err;

        const updatedErr = { ...err };

        if (name === "department") {
          // Clear department error
          delete updatedErr.department;
          // Also clear designation error since it's reset
          delete updatedErr.designation;
        } else if (name === "exp_designation") {
          // Clear designation error
          delete updatedErr.designation;
        }

        return updatedErr;
      })
    );

    if (name === "department") {
      GetDesignation(option.id, index);
    }
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    if (name === "category") {
      if (checked) {
        setCategory([...category, value]);
      } else {
        setCategory(category.filter((item) => item !== value));
      }
      setError({
        ...error,
        [name]: "",
      });
    } else if (name === "panelTechType") {
      setFormData((prevList) => ({
        ...prevList,
        is_eligible_class: value === "0" ? 0 : 1,
      }));
      setError({
        ...error,
        jobType: "",
      });
    } else if (name === "phoneNumber") {
      if (value.length === 10 || value.length === 0) {
        setFormData((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError({
          ...error,
          ["phoneNumber"]: "",
        });
      } else {
        setFormData((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError({
          ...error,
          ["phoneNumber"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const handleSubmit = (e) => {
    // e.preventDefault(); // Prevent the default form submission behavior
    const useref_panelmembers = {
      firstName: txtPanelFName.current,
      lastName: txtPanelLName.current,
      phoneNumber: txtPanelPno.current,
      email: txtPanelEmail.current,
      status: txtPanelStatus.current,
    };
    const errors = validatePanelMember(fData, useref_panelmembers, addJob);
    const { jobErrors, ...fieldErrors } = errors;
    if (
      Object.keys(fieldErrors).length === 0 &&
      jobErrors.every((jobErr) => Object.keys(jobErr).length === 0)
    ) {
      try {
        if (userId) {
          const mappedDatas = addJob.map((item) => ({
            department_id: item.department_id,
            designation_id: item.designation_id,
            department: item.department,
            exp_designation: item.exp_designation,
          }));

          const updateStaff = {
            user_id: userId,
            first_name: fData.fname,
            last_name: fData.lname,
            mobile_no: fData.phoneNumber,
            country_code: fData.phone_code,
            email: fData.email,
            staff_type: 3,
            job_info: mappedDatas,
            is_eligible_class: fData.is_eligible_class,
            // exp_designation: fData.designation,
            status: parseInt(fData.status),
            // department:fData.department,
            created_by: userid,
            updated_by: userid,
          };

          AxiosInstance.post("api/staff/register/edit", updateStaff)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                navigateToPreviousScreen();
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          const firstItem = addJob[0];
          if (firstItem.department !== "" && firstItem.exp_designation !== "") {
            const mappedData = addJob.map((item) => ({
              department_id: item.department_id,
              designation_id: item.designation_id,
              department: item.department,
              exp_designation: item.exp_designation,
            }));
            const createStaff = {
              first_name: fData.fname,
              last_name: fData.lname,
              mobile_no: fData.phoneNumber,
              country_code: fData.phone_code,
              email: fData.email,
              staff_type: 3,
              job_info: mappedData,
              is_eligible_class: fData.is_eligible_class,
              // exp_designation: fData.designation,
              status: parseInt(fData.status),
              // department:fData.department,
              created_by: userid,
            };
            AxiosInstance.post("api/user/register/staff", createStaff)
              .then((res) => {
                if (res.data.status === true) {
                  toast.success(res.data.message);
                  navigateToPreviousScreen();
                } else {
                  toast.error(res.data.message);
                  // navigateToPreviousScreen();
                }
              })
              .catch((error) => {
                return error;
              });
          } else {
            alert("Please select job info");
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(fieldErrors);
      setErrDep(jobErrors);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const fetchedIndexesRef = useRef(new Set());

  useEffect(() => {
    addJob.forEach((job, index) => {
      if (job.department_id !== "" && !fetchedIndexesRef.current.has(index)) {
        fetchedIndexesRef.current.add(index); // mark this index as fetched
        GetDesignation(job.department_id, index);
      }
    });
  }, [addJob]);

  return (
    <div className="Faculty BathHeader global_container">
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {userId ? "Edit Panel Member" : "Add New Panel Member"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                className="secondaryButton"
                variant="secondary"
                onClick={navigateToPreviousScreen}
              >
                Back to Panel Member
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center"
                variant="primary"
              >
                {userId ? "Save Panel Member" : "Save Panel Member"}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="row m-0 mb-4">
        <fieldset className="mt-3">
          <legend className="w-auto">Basic Details</legend>
          <form className="row g-3">
            <div class="col-md-6">
              <label for="CourseName" class="form-label confirm_value ">
                First Name
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                ref={txtPanelFName}
                type="text"
                id="fname"
                name="fname"
                value={fData.fname}
                onChange={handleChange}
                placeholder="Enter the First Name"
                required
              />
              {error.fname && (
                <small className="error_message">{error.fname}</small>
              )}
            </div>
            <div className="col-md-6">
              <label for="AAdmissionType" class={"form-label confirm_value "}>
                Last Name
              </label>
              <input
                ref={txtPanelLName}
                type="text"
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                id="lname"
                name="lname"
                value={fData.lname}
                onChange={handleChange}
                placeholder="Enter the Last Name"
                required
              />
              {error.lname && (
                <small className="error_message">{error.lname}</small>
              )}
            </div>

            <div class="col-md-6">
              <label for="Category" class={"form-label confirm_value "}>
                Phone Number
              </label>
              <input
                ref={txtPanelPno}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="number"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="Enter the phone number"
                value={fData.phoneNumber}
                onChange={handleChange}
                required
                minLength={10}
                maxLength={10}
              />
              {error.phoneNumber && (
                <small className="error_message">{error.phoneNumber}</small>
              )}
            </div>
            <div class="col-md-6">
              <label for="CourseGrouping" class={"form-label confirm_value "}>
                Email ID
              </label>
              <input
                ref={txtPanelEmail}
                type="email"
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                id="email"
                name="email"
                disabled={userId ? true : false}
                value={fData.email}
                onChange={handleChange}
                placeholder="Enter the Email ID"
                required
              />
              {error.email && (
                <small className="error_message">{error.email}</small>
              )}
            </div>

            <div class="col-md-6">
              <label for="CourseGrouping" class={"form-label confirm_value "}>
                Status
              </label>
              <select
                ref={txtPanelStatus}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                id="status"
                name="status"
                value={fData.status}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Please select status
                </option>
                <option value="4" selected>
                  Active
                </option>
                {userId && <option value="3">Inactive</option>}
              </select>
              {error.status && (
                <small className="error_message">{error.status}</small>
              )}
            </div>

            <div className="col-md-6">
              <label htmlFor="CourseName" className="form-label confirm_value">
                Job Type
              </label>

              <div className="d-flex gap-4 align-items-center">
                <div className=" d-flex align-items-center gap-2">
                  <input
                    className="checkbox_radio"
                    type="radio"
                    style={{ marginTop: 0, marginRight: 0 }}
                    name="panelTechType"
                    id="Teaching"
                    value="1"
                    checked={
                      fData.is_eligible_class === "1" ||
                      fData.is_eligible_class === 1
                    }
                    onChange={handleChange}
                  />
                  <label className="confirm_value" htmlFor="Teaching">
                    Teaching
                  </label>
                </div>

                <div className=" d-flex align-items-center gap-2">
                  <input
                    className="checkbox_radio"
                    type="radio"
                    name="panelTechType"
                    id="NonTeaching"
                    value="0"
                    checked={
                      fData.is_eligible_class === "0" ||
                      fData.is_eligible_class === 0
                    }
                    onChange={handleChange}
                    style={{ marginTop: 0, marginRight: 0 }}
                  />
                  <label className="confirm_value" htmlFor="NonTeaching">
                    Non Teaching
                  </label>
                </div>
              </div>

              {error.jobType && (
                <small className="error_message">{error.jobType}</small>
              )}
            </div>
          </form>
        </fieldset>
      </div>

      {addJob.map((item, index) => (
        <AddJobInfo
          key={index.toString()}
          record={item}
          index={index}
          jobError={errDep[index] || {}}
          length={addJob.length}
          handleChangeAjob={handleChangeAjob}
          handleChangeAjobs={handleChangeAjobs}
          department={department}
          designation={item?.designationOptions}
          DeleteAddJobinfo={DeleteAddJobinfo}
          handleAddJobinfo={handleAddJobinfo}
        />
      ))}

      <div className="row">
        <div className="col-md-6 col-12 ms-auto ListBtn">
          <ul className="List-Button d-flex justify-content-end">
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                className="secondaryButton"
                variant="secondary"
                onClick={navigateToPreviousScreen}
              >
                Back to Panel Member
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center"
                variant="primary"
              >
                {userId ? "Save Panel Member" : "Save Panel Member"}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default AddPanelMember;
